import { BaseUxGameListener } from './base-ux-game-listener';
import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { PAGE } from 'src/app/routes';
import { TwentyOne } from 'game-logic';

export class TwentyOneUxGameListener
  extends BaseUxGameListener
  implements TwentyOne.TwentyOneListener
{
  constructor(private services: UxGameServices) {
    super();
  }

  async onFatalError(context: string, error: unknown): Promise<void> {
    await this.services.analyticsService.handleError(error, context);

    const alert = await this.services.alertController.create({
      header: this.services.translocoService.translate('service.alert.fatal-reload-error-title'),
      message: this.services.translocoService.translate('service.alert.fatal-reload-error-message'),
      cssClass: 'alert',
      buttons: [
        {
          text: this.services.translocoService.translate('service.alert.ok-button'),
          cssClass: 'alert-button',
          handler: async () => {
            this.services.router.navigate([PAGE.LOADING]);
          },
        },
      ],
      backdropDismiss: false,
    });
    await alert.present();
  }
}
